import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	FormGroup,
	Row,
	Card,
	CardImg,
	CardBody,
	CardText,
	Modal,
	ModalBody,
	ModalHeader,
} from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import compoundLogo from "assets/images/compound.png";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import ResaleCard from "./ResaleCard";
import UnitCard from "./UnitCard";
import Paginator from "../Paginator";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ProfileService from "services/Website/ProfileService";
import Pagination from "components/InternalPagination";
import UploadReceiptModal from "components/Website/Cards/UploadReceiptModal";
import Select from "react-select";
import DeleteMultiModal from "components/Common/DeleteMultiModal";
import DeleteModal from "./DeleteModal";
import DealService from "services/Website/DealService";

const MyDeals = ({ history, deals, setProfileData }) => {
	const profileService = new ProfileService();
	const dealService = new DealService();
	const [shouldGetData, setShouldGetData] = useState(false);
	const [dealsData, setDealsData] = useState(false);
	const [hasData, setHasData] = useState(null);
	const [dealsDataPages, setDealsDataPages] = useState(null);
	const { t } = useTranslation();
	const [deleteAllModal, setDeleteAllModal] = useState(false);
	const [status, setStatus] = useState(""); // {label: 'Show All', value: ''}
	const [formState, setFormState] = useState({
		media_id: "",
		media_id_path: "",
	});

	useEffect(() => {
		let params = !!status?.value && {
			status: status?.value,
		};
		profileService.getDeals(params).then((response) => {
			if (response && response.status === SuccessOk) {
				// let newDeals = []
				// response.data?.map(deal=> {
				//     if(deal.status === 'Open'){
				//         newDeals.push(deal)
				//     }
				// })
				setDealsData(response.data);
				if (!!response.data?.length) {
					setHasData(1);
				} else {
					setHasData(0);
				}
			}
		});
	}, [status, shouldGetData]);

	const onChangeDeals = (listData) => {
		setDealsDataPages([...listData]);
	};

	const updateDeals = (id) => {
		const updatedDealsData = deals.filter((deal) => {
			if (deal.id === id) {
				return false;
			} else {
				return true;
			}
		});
		setProfileData((data) => ({
			...data,
			deals: [...updatedDealsData],
		}));
	};
	return (
		<div className="websitPages tab-details interst-tab">
			<div className="px-lg-5 px-3 py-5">
				<div className="d-md-flex justify-content-between align-items-center">
					<h3
						className="text-primary fw-bold font-size-26"
						dangerouslySetInnerHTML={{
							__html: t("My Deals Title"),
						}}></h3>
					<div className="d-flex" style={{ gap: "12px" }}>
						<Select
							name="payment"
							placeholder="Status"
							isClearable
							className="status-select"
							options={[
								// {label: 'Show All', value: ''},
								{ label: "Uncontacted", value: "Uncontacted" },
								{ label: "Contacted", value: "Contacted" },
								{ label: "Open", value: "Open" },
								{ label: "Closed", value: "Closed" },
								{ label: "Won", value: "Won" },
								{ label: "Lost", value: "Lost" },
								{ label: "Unreachable", value: "Unreachable" },
								{ label: "Pending", value: "Pending" },
							]}
							value={status}
							onChange={(data) => setStatus(data)}
						/>
						<button
							className="text-decoration-underline text-primary border-0"
							style={{
								background: "none",
							}}
							onClick={() => setDeleteAllModal(true)}>
							Remove All
						</button>
					</div>
				</div>
				<Row className="pt-4">
					{hasData === 1 &&
						dealsData?.map((deal, index) => {
							if (!!deal.unit) {
								return (
									<Col lg={4} md={6} key={index} className="mb-3 px-3">
										<UnitCard
											item={{
												...deal.unit,
												phone: deal?.sales_rep?.phone,
												deal_id: deal.id,
												reciept: deal.reciept,
												status: deal?.status,
											}}
											index={index}
											setShouldGetData={setShouldGetData}
											history={history}
											profile={true}
										/>
									</Col>
								);
							} else {
								return (
									<Col md={4} key={index} className="mb-3 px-3">
										<ResaleCard
											item={{
												...deal.resale,
												phone: deal?.sales_rep?.phone,
												deal_id: deal.id,
												reciept: deal.reciept,
												status: deal?.status,
											}}
											index={index}
											history={history}
											profile={true}
											setShouldGetData={setShouldGetData}
										/>
									</Col>
								);
							}
						})}
					{hasData === 0 && <p className="m-0">No results match the filter.</p>}
				</Row>

				{dealsData?.length > 0 && (
					<Row className="d-flex justify-content-end">
						<Pagination items={dealsData} onChangePage={onChangeDeals} />
					</Row>
				)}
			</div>
			{deleteAllModal && (
				<DeleteModal
					setShouldGetData={setShouldGetData}
					open={deleteAllModal}
					titleMsg={"Deals"}
					deletedItem={dealsData}
					params={{
						deal_ids: dealsData?.map((res) => res?.id),
						status: "Removed",
					}}
					modelService={dealService}
					onCloseModal={() => setDeleteAllModal(false)}
				/>
			)}
		</div>
	);
};
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default MyDeals;
